var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","disabled":_vm.noTooltip},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({class:_vm.contentClass},on),[_vm._v(_vm._s(_vm.relDateTimeString))])]}}])},[_vm._v(" "+_vm._s(_vm.dateTimeString)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }